<template>
  <div class="card floating">
    <div class="card-content">
      <p>{{ $t('prompts.deletePrivateSpace') }}</p>
    </div>
    <div class="card-action">
      <button @click="$store.commit('closeHovers')" id ="buttonCancelDelete"
        class="button button--flat button--grey"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button @click="submit"
        class="button button--flat button--red" id ="buttonDelete"
        :aria-label="$t('buttons.delete')"
        :title="$t('buttons.delete')">{{ $t('buttons.delete') }}</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { files as api } from '@/api';

export default {
  name: 'delete-private-space',
  computed: {
    ...mapState([
      'handleOpenSpace'
    ]),
  },
  methods: {
    ...mapMutations(['closeHovers']),
    submit: async function () {
      try {
        await api.deleteSecret(this.handleOpenSpace);
        this.$router.push({path: '/cloud'});
      } catch (e) {
        this.$showError(e);
      }
    }
  },
};
</script>